"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAccordionBlocksProperty = exports.accordionBlocksPropertyDefinition = void 0;
exports.accordionBlocksPropertyDefinition = {
    view: { label: 'Accordion Blocks' },
    constraints: [
        {
            name: 'properties',
            argument: ['accordion-block'],
        },
        {
            name: 'minLength',
            argument: 1,
        },
    ],
    type: 'container',
    multiple: true,
    name: 'accordion-blocks',
};
const isAccordionBlocksProperty = (prop) => {
    return prop.name === exports.accordionBlocksPropertyDefinition.name;
};
exports.isAccordionBlocksProperty = isAccordionBlocksProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWNjb3JkaW9uLWJsb2Nrcy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2FjY29yZGlvbi1ibG9ja3MucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxpQ0FBaUMsR0FBRztJQUMvQyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsa0JBQWtCLEVBQUU7SUFDbkMsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsWUFBWTtZQUNsQixRQUFRLEVBQUUsQ0FBQyxpQkFBaUIsQ0FBQztTQUM5QjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLENBQUM7U0FDWjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFdBQVc7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsa0JBQWtCO0NBQ08sQ0FBQTtBQUkxQixNQUFNLHlCQUF5QixHQUFHLENBQUMsSUFBa0IsRUFBbUMsRUFBRTtJQUMvRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsseUNBQWlDLENBQUMsSUFBSSxDQUFBO0FBQzdELENBQUMsQ0FBQTtBQUZZLFFBQUEseUJBQXlCLDZCQUVyQyJ9